module.exports = __webpack_public_path__ + "static/start_money_bg-8fec94174663c38253db65e29d3f2ffb.svg";